<template>
  <ListagemBase
    nomePlural="LogTransacoes"
    nomeSingular="LogTransacao"
    :headers="headers"
    :botaoCadastro="false"
  />
</template>

<script>
import LogTransacaoDataService from "@/services/software/LogTransacaoDataService";
import ListagemBase from "@/components/base/Crud/ListagemBase";

export default {
  name: "ListagemLogAuditoria",
  components: { ListagemBase },
  data() {
    return {
      DataService: LogTransacaoDataService,
      headers: [
        {
          text: this.$t("Responsavel"),
          value: "responsavel.nome",
          sortable: false,
        },
        { text: this.$t("Dominio"), value: "dominio", sortable: false },
        { text: this.$t("Tipo"), value: "tipo", sortable: false },
        {
          text: this.$t("Data_de_alteracao"),
          value: "dtAlteracao",
          sortable: false,
        },
        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],
    };
  },
};
</script>

<style scoped></style>
